import React from "react";
import { Star } from "lucide-react";
import Slider from "./Slider";
import { useT } from "../lib/i18n";

const REVIEWS = [
  { name: "Priya Kulkarni", route: "Pune → Palus", text: "Reached home safe & on time. Driver was very courteous. Highly recommended!", rating: 5, avatar: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg" },
  { name: "Sagar Deshmukh", route: "Ashtavinayak Yatra", text: "Family loved the darshan trip. Every detail managed by Shruti team.", rating: 5, avatar: "https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg" },
  { name: "Anjali Patil", route: "Pune → Mumbai Airport", text: "Booked at 3AM pickup. Reached airport well ahead. Perfect service.", rating: 5, avatar: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg" },
  { name: "Rahul Sawant", route: "Corporate Transfer", text: "Used for 15-day corporate transfers. Very reliable, clean vehicles.", rating: 5, avatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg" },
  { name: "Neha Joshi", route: "Vaishnodevi Tour", text: "First North India tour with elders — Shruti handled everything.", rating: 5, avatar: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg" },
  { name: "Kiran Bhosale", route: "Palus → Pune Daily", text: "Daily commuters like me can count on the 6 AM Traveller.", rating: 5, avatar: "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg" },
];

function Card({ r }) {
  return (
    <div className="w-[80vw] max-w-[340px] p-5 rounded-2xl bg-white border border-slate-200 shadow-sm" data-testid={`testimonial-${r.name.replace(/\s/g,'-').toLowerCase()}`}>
      <div className="flex items-center gap-3">
        <img src={r.avatar} className="w-10 h-10 rounded-full object-cover" alt={r.name} />
        <div>
          <div className="font-display font-bold text-[var(--brand-navy)] text-sm">{r.name}</div>
          <div className="text-xs text-slate-500">{r.route}</div>
        </div>
      </div>
      <div className="flex mt-3 text-amber-500">
        {Array.from({length: r.rating}).map((_,i)=><Star key={i} className="w-4 h-4 fill-current" />)}
      </div>
      <p className="text-sm text-slate-700 mt-2 leading-relaxed">"{r.text}"</p>
    </div>
  );
}

export default function Testimonials() {
  const t = useT();
  return (
    <section className="max-w-7xl mx-auto px-4 mt-20" data-testid="testimonials-section">
      <div className="text-center mb-8">
        <div className="text-xs uppercase tracking-widest text-[var(--brand-orange)] font-semibold">{t("test.eyebrow")}</div>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold tracking-tight text-[var(--brand-navy)]">{t("test.title")}</h2>
      </div>
      <div className="px-6 md:px-8">
        <Slider testid="testimonials-slider" autoPlay interval={5000}>
          {REVIEWS.map((r, i) => <Card key={i} r={r} />)}
        </Slider>
      </div>
    </section>
  );
}
